/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `LinkType*`'s.
 */
export type LinkType = LinkTypeButton | LinkTypeStandalone | LinkTypeParagraph;

/**
 * The Link button type.
 */
export type LinkTypeButton = typeof LINK_TYPE_BUTTON;

/**
 * The Link standalone type.
 */
export type LinkTypeStandalone = typeof LINK_TYPE_STANDALONE;

/**
 * The Link paragraph type.
 */
export type LinkTypeParagraph = typeof LINK_TYPE_PARAGRAPH;

/**
 * The Link button constant.
 */
export const LINK_TYPE_BUTTON = `button`;

/**
 * The Link standalone constant.
 */
export const LINK_TYPE_STANDALONE = `standalone`;

/**
 * The Link paragraph constant.
 */
export const LINK_TYPE_PARAGRAPH = `paragraph`;
